var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helmi-icon",style:(_vm.rootStyles)})
}
var staticRenderFns = []

export { render, staticRenderFns }